import { IdentityLoginMethods } from 'altru-types';
import { AltruApiResponse } from 'altru-types/@types/generic-response';
import { Api } from '@/store/api';

export async function getLoginMethods(email: string): Promise<AltruApiResponse<IdentityLoginMethods>> {
  const response = await Api.get(`/api/us/identities/login_methods?email=${encodeURIComponent(email)}`);
  return response.data;
}
